import React, { Component } from "react";
import NavDE from "../Symbols/NavDE"; // Consider using a NavEN component if this page is English-first
import { Link } from "react-router-dom";
import FooterDE from "../Symbols/FooterDE"; // Consider using a FooterEN component if English
import { Helmet } from "react-helmet-async";
import "../../stylesheets/AboutUs.css";

// PLACEHOLDER IMAGE IMPORTS - Replace these with your actual image paths
import PlaceholderHero from "../../assets/1_hap15041_RGB_MidRes (1).jpg";
import PlaceholderComp1 from "../../assets/precision stamping technology.jpg";
import PlaceholderComp2 from "../../assets/2_hap15003 (1).jpg";
import PlaceholderComp3 from "../../assets/Precision toolmaking.jpg";
import PlaceholderComp4 from "../../assets/Spare and wear parts.jpg";
import PlaceholderPresses from "../../assets/8_0013 (1).jpg";
import PlaceholderPortfolioBg from "../../assets/4_0075 (1).jpg"; // For the red-bg split section

class StampingProducts extends Component {
  constructor(props) {
    super(props);
    this.intro = React.createRef();
  }

  introScroll = () => {
    let element = this.intro.current;
    let headerOffset = 45;
    let elementPosition = element.getBoundingClientRect().top;
    let offsetPosition = elementPosition + window.pageYOffset - headerOffset;

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth",
    });
  };

  render() {
    return (
      <div className="content">
        <Helmet>
          <title>Pancon - Stamping Products</title>
          <meta
            name="description"
            content="We combine precision engineering with modern manufacturing processes to meet the highest industrial standards. Stamping Quality made in Germany."
          />
          <meta property="og:title" content="Pancon - Stamping Products" />
          <meta
            property="og:description"
            content="We combine precision engineering with modern manufacturing processes to meet the highest industrial standards. Stamping Quality made in Germany."
          />
          <link
            rel="alternate"
            href="https://www.pancon.de/en/stamping-products"
            hrefLang="en"
          ></link>
        </Helmet>

        <NavDE />

        {/* HERO SECTION */}
        <div className="hero stamp" style={{ backgroundImage: `url(${PlaceholderHero})` }}>
          <div className="red-bg-hero"></div>
          <div className="hero-content new">
            <h1 className="hero-heading">Stamping Products</h1>
            <h2 className="hero-heading-2">Stamping Quality made in Germany</h2>
            <p className="hero-desc new">
              We combine precision engineering with modern manufacturing processes to meet the highest industrial standards.
            </p>
            <button onClick={this.introScroll} className="default inverted">
              Learn more
            </button>
          </div>
        </div>

        {/* CORE COMPETENCIES SECTION */}
        <div ref={this.intro} id="intro" className="section first flex center-h">
          <div className="medium flex col"> {/* Added 'col' to ensure proper vertical stacking of the header/text/grid */}
            <div className="heading1-cont flex center-v">
              <h2 className="alternate-heading">Our Core Competencies</h2>
            </div>
            <p className="body padding-default">
              Our expertise guarantees high-quality results from the initial idea all the way to serial production:
            </p>

            {/* Replaced Flexbox with a responsive CSS Grid */}
            <div
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
                gap: '2rem',
                width: '100%',
                marginTop: '1.5rem'
              }}
            >
              <div>
                <img className="img-full" src={PlaceholderComp1} alt="Precision stamping technology"></img>
                <h4>Precision stamping technology</h4>
                <p className="body">
                  for the best results possible
                </p>
              </div>
              <div>
                <img className="img-full" src={PlaceholderComp2} alt="Prototype manufacturing"></img>
                <h4>Prototype manufacturing</h4>
                <p className="body">
                  You have the idea, we have the tools to make it happen
                </p>
              </div>
              <div>
                <img className="img-full" src={PlaceholderComp3} alt="Precision toolmaking"></img>
                <h4>Precision toolmaking</h4>
                <p className="body">
                  no matter the difficulty, we can figure it out!
                </p>
              </div>
              <div>
                <img className="img-full" src={PlaceholderComp4} alt="Spare and wear parts"></img>
                <h4>Spare and wear parts</h4>
                <p className="body">
                  repeatable accuracy, flexibility and always on schedule
                </p>
              </div>
            </div>

          </div>
        </div>

        {/* STAMPING PORTFOLIO (RED BACKGROUND SPLIT) */}
        <div className="section full about-1 new-margin flex center-h center-v">
          <div className="half about-img-2 stamp" style={{ backgroundImage: `url(${PlaceholderPortfolioBg})` }}></div>
          <div className="half red-bg">
            <h4>Capabilities & Specs</h4>
            <h2>Stamping Portfolio & Prototypes</h2>
            <ul className="body inverted">
              <li><strong>Dimensions:</strong> Strip thickness: 0.05 - 2.0 mm | Strip width: up to 280 mm | Feed length: &lt; 1.00 mm</li>
              <li><strong>Products:</strong> Micro contacts / micro springs, Stamped grids, Complex components, Complete assemblies</li>
              <li><strong>Processes:</strong> In-process laser welding, Assembly operations in progressive dies, In-process riveting</li>
              <li><strong>Prototypes to Customer Requirements:</strong> Lasered or eroded, Stamped and bent using auxiliary tools, All common surface treatments/finishes, EloPin® from hapema</li>
            </ul>
          </div>
        </div>

        {/* HIGH-PERFORMANCE PRESSES SECTION */}
        <div className="section flex center-h">
          <div className="medium flex">
            <div className="heading1-cont flex center-v">
              <h2 className="alternate-heading">High-Performance Stamping Presses & Press-Fit Tech</h2>
            </div>
            <div className="half">
              <ul className="body">
                <li><strong>High-Performance Stamping Presses:</strong> from BRUDERER (30 - 80 tons)</li>
                <li><strong>Integrated Features:</strong> Camera inspection cells, Force-path monitoring, Laser welding unit, Laser marking, Cleaning system</li>
                <li><strong>Mechanical press-fit connection for PCBs:</strong> Enables chipless press-in and drastically reduces costs in the downstream process chain.</li>
                <li><strong>Available Sizes:</strong> 04-06 | 06-10 | 08-145 | 08-16 | 12-20. In general, all approved press-in zones can be realized.</li>
                <li><strong>Partnership:</strong> Development is carried out in close cooperation with our customers.</li>
              </ul>
            </div>
            <div className="half w-image">
              <img src={PlaceholderPresses} alt="High-Performance Stamping Presses"></img>
            </div>
          </div>
        </div>

        {/* OUR CUSTOMERS SECTION */}
        <div className="section flex center-h">
          <div className="medium flex col">
            <div className="heading1-cont flex center-v">
              <h2 className="alternate-heading">Our Customers</h2> {/* [cite: 30] */}
            </div>
            <p className="body padding-default">
              Are well-known companies in the following industries: {/* [cite: 31] */}
            </p>
            <div className="half">
              <ul className="body">
                <li>Automotive & Mobility {/* [cite: 32] */}</li>
                <li>Electrical & Electronics {/* [cite: 33] */}</li>
                <li>Household Appliances (White Goods) {/* [cite: 34] */}</li>
                <li>Medical Technology & Pharmaceuticals {/* [cite: 35] */}</li>
                <li>Consumer Goods {/* [cite: 36] */}</li>
                <li>Aviation & Aerospace {/* [cite: 37] */}</li>
              </ul>
            </div>
          </div>
        </div>

        {/* CALL TO ACTION SECTION */}
        <div className="section flex center-h">
          <div className="medium flex">
            <div className="half flex center-v center-h">
              <p className="eye-catcher accent">Pancon - Precision technology for your success</p>
              <p className="body s-18">
                Do you have a product idea or need a highly specialized stamping solution? We have the tools, the machines, and the experience to make it happen.
              </p>
            </div>
            <div className="half flex center-v center-h col">
              <Link className="default diff-1" to="/en/contact">
                <span>Contact us now</span>
              </Link>
              <p className="body s-18">We look forward to your inquiry!</p>
            </div>
          </div>
        </div>

        <FooterDE />
      </div>
    );
  }
}

export default StampingProducts;